import React from "react";
import { useState } from "react";
import Jaspreet from "../../assets/student/Jaspreet_10th.jpg";
import khushi from "../../assets/student/Khushi_10th.jpg";
import Prince from "../../assets/student/Prince_10th.jpg";
import kittu from "../../assets/student/Kittu_10th.jpg";

import "./Testimonial.css";
import { Link } from "react-router-dom";

const Testimonial = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const testimonials = [
    {
      name: "Jaspreet Singh",
      batch: "Class 12th",
      caption:
        "Attending ooklass classes has helped me tremendously in many ways. I have been able to improve my skills in both math and science, and as a result, I have been getting good scores in school. I am very happy that I decided to attend your tuition classes for my studies.",
      profileImgUrl: Jaspreet,
    },
    {
      name: "Khushi Garg",
      batch: "Class 10th",
      caption:
        "This tuition center is amazing! The tests, papers, and teaching methods were immensely helpful, and the instructor's cooperative and friendly nature made learning enjoyable. Highly recommended!",
      profileImgUrl: khushi,
    },
    {
      name: "Prince Godara",
      batch: "Class 10th",
      caption:
        "I had a great experience learning at this tuition center. I was able to learn new things that I didn't know before, and whenever I had a doubt or a question, the teacher was always there to help me out. The teacher also provided us with well-written notes for each chapter, which were very helpful in my studies. I am grateful to the teacher for their hard work and dedication, and for helping me improve my skills. Thank you, sir!",
      profileImgUrl: Prince,
    },
    {
      name: "Kittu Kumari",
      batch: "Class 10th",
      caption:
        "I had a great time studying at this tuition center. It was fun taking tests, and I especially appreciated the notes provided to us. The teacher put in a lot of effort throughout the course, and even started online classes to help those who were struggling. This was a very thoughtful and appreciable gesture on the teacher's part. Overall, I enjoyed my time at this tuition center and would highly recommend it.",
      profileImgUrl: kittu,
    },
  ];

  const handleSlide = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  return (
    <div
      className="testimonial bg-cover bg-center"
      style={{
        backgroundColor: "#FBEEE6",
        paddingTop: "100px",
        paddingBottom: "100px",
        borderRadius: "40px",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-sm-12">
            <h5 className="p-3 mx-2 orange-text fw-bold">Testimonial</h5>
            <h2 className="my-2 py-2 px-3 main-text fw-bolder">
              See What Our Student Say's
            </h2>
            <p className="fs-6 p-3 text-dark">
              "Read what our students have to say about their experience with
              Ooklass and how our personalized tutoring services have helped
              them achieve academic success."
            </p>
          </div>
          <div className="col-md-6 col-sm-12">
            <div
              id="testimonial-carousel"
              className="carousel slide"
              data-bs-ride="carousel"
              onChange={(e) => handleSlide(e.to)}
            >
              <div className="carousel-indicators">
                {testimonials.map((testimonial, index) => (
                  <button
                    type="button"
                    data-bs-target="#testimonial-carousel"
                    data-bs-slide-to={index}
                    className={index === activeIndex ? "active" : ""}
                    key={index}
                    aria-current={index === activeIndex ? "true" : ""}
                  ></button>
                ))}
              </div>
              <div className="carousel-inner">
                {testimonials.map((testimonial, index) => (
                  <div
                    className={
                      index === activeIndex
                        ? "carousel-item active"
                        : "carousel-item"
                    }
                    key={index}
                  >
                    <div className="d-flex align-items-center justify-content-start p-5 mt-2">
                      <div className="testimonial-img-container">
                        <img
                          src={testimonial.profileImgUrl}
                          alt={`Testimonial from ${testimonial.name}`}
                          className="testimonial-profile-img rounded-circle"
                        />
                      </div>
                      <div className="testimonial-caption">
                        <p>{testimonial.name}</p>
                        <span>{testimonial.batch}</span>
                      </div>
                    </div>
                    <div className="testimonial-detail">
                      <p className="p-1 fs-6 mx-3 text-align-center">
                        "{testimonial.caption}"
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {props.show && (
              <div className="text-center">
                <Link to="testimonial">
                  <button className="btn btn-orange btn-lg mt-5">
                    See More Reviews
                  </button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
